import type { Features } from '../contexts/FeaturesContext';

/**
 * Pure function: Check if facial scan feature is enabled
 * Input: Features object → Output: boolean
 *
 * @param features - Feature flags from FeaturesContext
 * @returns true if FSC:scan feature is enabled
 */
export const isFacialScanEnabled = (features: Features): boolean =>
  features['FSC:scan'] === true;

/**
 * Pure function: Check if historical survey import is enabled for the tenant.
 *
 * @param features - Feature flags from FeaturesContext
 * @returns true if HSI:import feature is enabled
 */
export const isHistoricalImportEnabled = (features: Features): boolean =>
  features['HSI:import'] === true;
